import { useEffect, useState } from 'react';
import { useAuth, useRouter } from '@webapps/reactjs-tech-components';
import { useLocation } from 'react-router-dom';
import { ROUTES_PATH } from 'config/constants';

const GoogleAuth = () => {
  const [code, setCode] = useState();
  const [accInfo, setAccInfo] = useState();
  const [loginPayload, setLoginPayload] = useState();
  const { loginGoogle } = useAuth();
  const location = useLocation();
  const { push } = useRouter();

  const { NX_REST_API } = process.env;

  const useQuery = () => {
    return new URLSearchParams(location.search);
  };

  useEffect(() => {
    const query = useQuery();
    const codeParam = query.get("code");
    if (!codeParam) return;
  
    setCode(codeParam);
  
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
  
    const rawJSON = JSON.stringify({
      code: codeParam
    });
  
    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: rawJSON,
      redirect: "follow"
    };
  
    fetch(`${NX_REST_API}/signup/individual/google`, requestOptions)
      .then(response => response.json())
      .then(async (result) => {
        const username = result.email;
        const email = result.email;
        const jwtToken = result.accessToken;
        const password = result.username;
  
        const payload = { username, jwtToken, email, password };
        
        setLoginPayload(payload);
  
        try {
          const loginResult = await loginGoogle(payload);
          setAccInfo(loginResult);
          push(ROUTES_PATH.STUDENT_DASHBOARD)
        } catch (error) {
          console.error(error);
        }
      })
      .catch(error => console.error(error));
  
  }, [location.search]);
  

  return (
    <div>
      <head>
        <title>Google Authentication</title>
        <meta name="description" content="Authenticate with Google" />
        <link rel="icon" href="/favicon.ico" />
      </head>
      {/* <pre>{JSON.stringify(accInfo, null, 2)}</pre>
      <pre>{code}</pre>
      <pre>Payload de la requête login: {JSON.stringify(loginPayload, null, 2)}</pre> */}
    </div>
  );
};

export default GoogleAuth;
